import { CldImage } from "next-cloudinary";
import React from "react";
import Visibility from "@/components/shared/Visibility";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { ImageProps } from "./types";

function Image({
  src,
  alt = "Image",
  width,
  height,
  fill = false,
  sizes = "100vw",
  quality = 75,
  aspectRatio,
  className,
  ...props
}: ImageProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Visibility shouldShow={!!src}>
      <CldImage
        src={src}
        alt={alt}
        width={width}
        height={height}
        fill={fill}
        sizes={sizes}
        quality={quality}
        aspectRatio={aspectRatio}
        className={cn(className, classes)}
        {...native}
      />
    </Visibility>
  );
}

export default Image;
